<template>
    <DefaultPanel class="flight-panel" title="Volo selezionato" :is-selected="selected">
        <template>
            <FlightSection :selected="selected" :value=value @detail="onOpenDetail" @select="onSelect" />
        </template>
        <template v-slot:modal>
            <ModalFlightDetail :value=value ref="modalFlightDetail" :selected="selected" @select="onSelect"/>
        </template>
    </DefaultPanel>
</template>

<script>
import DefaultPanel from '../../templates/DefaultPanel'
import ModalFlightDetail from './modals/ModalFlightDetail'
import FlightSection from './flight-panel/FlightSection'
import AnalyticEvents from '../../common/AnalyticEvents'
export default {
  name: 'FlightPanel',
  mixins: [AnalyticEvents],
  components: {FlightSection, ModalFlightDetail, DefaultPanel},
  props: {
    value: {
      type: Object
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onOpenDetail: function () {
      this.trackTabVoloInfoVoli()
      this.$refs.modalFlightDetail.open()
    },
    onSelect: function () {
      this.trackTabVoloSelezionaVolo()
      this.$emit('select', this.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/FlightPanel.vue